module.exports = __webpack_public_path__ + "assets/img/sBgBorder.7d401d40.png";